import SelectRadio from '@/components/shared/SelectRadio';
import useClaimCreateStore from '@/store/claimCreateStore';
import { InputHTMLAttributes } from 'react';
import { UseFormRegister, FieldValues } from 'react-hook-form';

const TreatmentStateInput = (
  props: InputHTMLAttributes<HTMLInputElement> & {
    selectedValue?: string;
    register: UseFormRegister<FieldValues>;
    onOptionSelect?: (value?: string) => void;
  }
) => {
  const currentFeatureCategory = useClaimCreateStore(
    (state) => state.currentFeatureCategory
  );

  const setFormState = useClaimCreateStore((state) => state.setFormState);

  return (
    <div className="flex flex-col gap-4 md:gap-5">
      {currentFeatureCategory?.treatmentStageOptionList?.map((option) => {
        return (
          <SelectRadio
            key={option.slug}
            id={option.slug}
            value={option.slug}
            title={option.title}
            description={option.subtitle}
            selected={props.selectedValue === option.slug}
            {...props}
            {...props.register('treatmentStage', {
              required: 'Please select a treatment stage',
              onChange: () => {
                props?.onOptionSelect?.(option.slug);
                const dateFieldName =
                  currentFeatureCategory.formSchema?.[option.formSchemaField]
                    .field;
                setFormState({ dateFieldName });
              },
            })}
          />
        );
      })}
    </div>
  );
};

export default TreatmentStateInput;
